import { render, staticRenderFns } from "./boardDetailPage.vue?vue&type=template&id=fa2fb8f2&scoped=true&"
import script from "./boardDetailPage.vue?vue&type=script&lang=js&"
export * from "./boardDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./boardDetailPage.vue?vue&type=style&index=0&id=fa2fb8f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2fb8f2",
  null
  
)

export default component.exports